import React from "react";

function NotFound() {
  return (
    <div
      style={{
        color: "white",
        height: "60vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <div>
        <i className="fas fa-chart-bar" style={{ fontSize: 120 }}></i>
        <div>Tab does not exist</div>
      </div>
    </div>
  );
}

export default NotFound;
